import './scripts/common';
import './scripts/common-nav';
import {onFind} from "@elements/init-modules-in-scope";
import {closest, on, findIn} from '@elements/dom-utils';

let _config = window['_config'] || {};

// @ts-ignore
window.app = window['app'] || {
    debug: false,
};

import * as smoothScroll from "@elements/smooth-scroll";
smoothScroll.init();


const isMobile = () => matchMedia('(max-width: 767px)').matches;
import * as scrollSlider from '@elements/scroll-slider';
scrollSlider.init({
    arrowIconClass:"icon icon-chevron",
    slides: isMobile() ? 2 : 6,
});

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);

    on('shown.bs.tab', function () {

        // quick fix - todo check if slider exists
        scrollSlider.init({
            arrowIconClass:"icon icon-chevron"
        });

    }, element);
});

import * as ajaxModal from './scripts/ajax-modal';
ajaxModal.init();
